import countryNames from "react-phone-number-input/locale/en.json";

const knownCountries = new Map<string, string>();
Object.entries(countryNames).forEach(([code, name]) => {
	// The installed country catalogue also contains phone-field UI labels.
	if (/^[A-Z]{2}$/.test(code) && code !== "ZZ") {
		knownCountries.set(code.toLowerCase(), name);
		knownCountries.set(name.toLowerCase(), name);
	}
});
const aliases: Record<string, string> = {
	usa: "US", "united states of america": "US", uk: "GB", "great britain": "GB",
	"czech republic": "CZ", czechia: "CZ", "republic of korea": "KR", korea: "KR",
	"russian federation": "RU", "viet nam": "VN", türkiye: "TR", turkey: "TR",
};
Object.entries(aliases).forEach(([alias, code]) => {
	const country = knownCountries.get(code.toLowerCase());
	if (country) knownCountries.set(alias, country);
});
const recognizedCountry = (value: unknown): string =>
	typeof value === "string" ? knownCountries.get(value.trim().toLowerCase()) || "" : "";

// Public peers only. A street, suburb or arbitrary alphabetic suffix is never
// a country. Legacy city may supply only a recognized final country component.
export const publicProfileCountry = (country: unknown, legacyCity?: unknown): string => {
	const structured = recognizedCountry(country);
	if (structured) return structured;
	if (typeof legacyCity !== "string") return "";
	return recognizedCountry(legacyCity) || recognizedCountry(legacyCity.split(",").pop());
};

export const sanitizePublicProfileLocation = <T extends object>(profile: T): T => {
	const location = profile as { city?: unknown; country?: unknown; lat?: unknown; lng?: unknown };
	if (!["city", "country", "lat", "lng"].some((key) => Object.prototype.hasOwnProperty.call(profile, key))) {
		return profile;
	}
	const country = publicProfileCountry(location.country, location.city);
	return { ...profile, city: country, country, lat: null, lng: null };
};
